import {Model} from "ords/dist/model/model";

export class Skill_Tree extends Model {
    getEducationLevelsByEducationLevel() {
        let levels = [];

        skillTreeLoop: for (const school_education_level_skill_tree of this.school_education_level_skill_trees){

            for (const level of levels) {
                if (level.id === school_education_level_skill_tree.school_education_levels.id) {
                    if (!level.years.includes(school_education_level_skill_tree.year)) {
                        level.years.push(school_education_level_skill_tree.year);
                        continue skillTreeLoop;
                    }
                }
            }
            levels.push({
                id: school_education_level_skill_tree.school_education_levels.id,
                name: school_education_level_skill_tree.school_education_levels.name,
                years: [school_education_level_skill_tree.year]
            })
        }

        return levels
    }
}

export const Skill_TreeModelConfig = {
    name: 'skill_tree',
    model: Skill_Tree,
    relations: [
        {name: 'skill_skill_trees', model_name: 'skill_skill_trees', type: 'hasMany'},
        {name: 'school_education_levels', model_name: 'school_education_levels', type: 'hasMany'},
        {name: 'school_education_level_skill_trees', model_name: 'school_education_level_skill_trees', type: 'hasMany'},
    ]
}
